export const ZeroOneKLessons = [
  {
    lessonNumber: 1,
    lessonTitle: "Returning Home After Many Years",

    PreKoreanWord1: "As I packed my bags, there was one",
    KoreanWord1: "것",
    KoreanWord1EngTranslation: "thing",
    PostKoreanWord1: "I knew for certain: I had to go back.",

    PreKoreanWord2: "There were many reasons to",
    KoreanWord2: "하다",
    KoreanWord2EngTranslation: "to do",
    PostKoreanWord2: "this, but the biggest was family.",

    PreKoreanWord3: "My parents were still",
    KoreanWord3: "있다",
    KoreanWord3EngTranslation: "to exist, to have, to be",
    PostKoreanWord3: "in the same old house.",

    PreKoreanWord4: "My memories also",
    KoreanWord4: "있어요",
    KoreanWord4EngTranslation: "to exist, to have, to be",
    PostKoreanWord4: "just as I had left them.",

    PreKoreanWord5: "No matter how busy life",
    KoreanWord5: "되다",
    KoreanWord5EngTranslation: "to become",
    PostKoreanWord5: "I couldn’t delay this trip anymore.",

    PreKoreanWord6: "I wasn’t sure if I",
    KoreanWord6: "수 있다",
    KoreanWord6EngTranslation: "can do, be able to do",
    PostKoreanWord6: "face everything calmly.",

    PreKoreanWord7: "Still, I decided I",
    KoreanWord7: "할 수 있어요",
    KoreanWord7EngTranslation: "can do",
    PostKoreanWord7: "and let things unfold.",

    PreKoreanWord8: "When the train arrived,",
    KoreanWord8: "나",
    KoreanWord8EngTranslation: "I, me",
    PostKoreanWord8: "felt a mix of nerves and excitement.",

    PreKoreanWord9: "I stared out the window, thinking about",
    KoreanWord9: "그",
    KoreanWord9EngTranslation: "that",
    PostKoreanWord9: "town I had left behind.",

    PreKoreanWord10: "Back then I felt I had",
    KoreanWord10: "없다",
    KoreanWord10EngTranslation: "to not have; to not exist",
    PostKoreanWord10: "any choice but to leave.",

    PreKoreanWord11: "But I tried",
    KoreanWord11: "않다",
    KoreanWord11EngTranslation: "to not do",
    PostKoreanWord11: "think negatively.",

    PreKoreanWord12: "Many",
    KoreanWord12: "사람",
    KoreanWord12EngTranslation: "people",
    PostKoreanWord12: "had probably changed since then.",

    PreKoreanWord13: "But deep down I hoped",
    KoreanWord13: "우리",
    KoreanWord13EngTranslation: "we, us",
    PostKoreanWord13: "could reconnect like before.",

    PreKoreanWord14: "I thought about",
    KoreanWord14: "이",
    KoreanWord14EngTranslation: "this",
    PostKoreanWord14: "moment for years.",

    PreKoreanWord15: "So much of my past was tied to",
    KoreanWord15: "그거",
    KoreanWord15EngTranslation: "that, this",
    PostKoreanWord15: "place.",

    PreKoreanWord16: "I wondered if leaving was really",
    KoreanWord16: "아니다",
    KoreanWord16EngTranslation: "to not be",
    PostKoreanWord16: "the right choice.",

    PreKoreanWord17: "I was",
    KoreanWord17: "보다",
    KoreanWord17EngTranslation: "to see, watch, look",
    PostKoreanWord17: "and thought the scenery was different.",

    PreKoreanWord18: "The mountains, trees, rivers,",
    KoreanWord18: "등",
    KoreanWord18EngTranslation: "etc., and so on",
    PostKoreanWord18: "seemed less amazing.",

    PreKoreanWord19: "Was this the right",
    KoreanWord19: "때",
    KoreanWord19EngTranslation: "time",
    PostKoreanWord19: "to come back?",

    PreKoreanWord20: "Everything felt like the same old",
    KoreanWord20: "거",
    KoreanWord20EngTranslation: "thing",
    PostKoreanWord20: "yet completely different.",

    PreKoreanWord21: "Part of me really",
    KoreanWord21: "보고 싶다",
    KoreanWord21EngTranslation: "want to see",
    PostKoreanWord21: "how much had changed.",

    PreKoreanWord22: "But another part felt strangely",
    KoreanWord22: "같다",
    KoreanWord22EngTranslation: "similar, same",
    PostKoreanWord22: "to my younger self.",

    PreKoreanWord23: "I bought a small gift to",
    KoreanWord23: "주다",
    KoreanWord23EngTranslation: "to give",
    PostKoreanWord23: "my parents when I arrived.",

    PreKoreanWord24: "I didn’t know how to",
    KoreanWord24: "대하다",
    KoreanWord24EngTranslation: "to deal with, to treat",
    PostKoreanWord24: "the emotions waiting for me.",

    PreKoreanWord25: "Still, I decided to",
    KoreanWord25: "가다",
    KoreanWord25EngTranslation: "to go",
    PostKoreanWord25: "forward without hesitation.",

    PreKoreanWord26: "It had been many",
    KoreanWord26: "년",
    KoreanWord26EngTranslation: "years",
    PostKoreanWord26: "since I last walked those streets.",

    PreKoreanWord27: "Too many things had happened all at",
    KoreanWord27: "한",
    KoreanWord27EngTranslation: "one; a single",
    PostKoreanWord27: "time back then.",

    PreKoreanWord28: "I never explained in",
    KoreanWord28: "말",
    KoreanWord28EngTranslation: "words, speech",
    PostKoreanWord28: "why I left.",

    PreKoreanWord29: "Life took me to",
    KoreanWord29: "일",
    KoreanWord29EngTranslation: "work, job; matter, affair",
    PostKoreanWord29: "far from home.",

    PreKoreanWord30: "But returning made all",
    KoreanWord30: "이",
    KoreanWord30EngTranslation: "this",
    PostKoreanWord30: "suddenly feel real again.",

    PreKoreanWord31: "Maybe leaving had been",
    KoreanWord31: "때문에",
    KoreanWord31EngTranslation: "because of",
    PostKoreanWord31: "pressure I felt as a young adult.",

    PreKoreanWord32: "I wanted to finally",
    KoreanWord32: "말하다",
    KoreanWord32EngTranslation: "to speak",
    PostKoreanWord32: "the truth about my struggles.",

    PreKoreanWord33: "I hoped they would understand I left",
    KoreanWord33: "위하다",
    KoreanWord33EngTranslation: "to care for, do for the sake of",
    PostKoreanWord33: "my own future.",

    PreKoreanWord34: "The years were long,",
    KoreanWord34: "그러나",
    KoreanWord34EngTranslation: "however",
    PostKoreanWord34: "they passed quicker than I realized.",

    PreKoreanWord35: "When the train finally began to",
    KoreanWord35: "오다",
    KoreanWord35EngTranslation: "to come",
    PostKoreanWord35: "into the station, my heart raced.",

    PreKoreanWord36: "Would they",
    KoreanWord36: "알다",
    KoreanWord36EngTranslation: "to know",
    PostKoreanWord36: "how much I missed them?",

    PreKoreanWord37: "A neighbor named Kim",
    KoreanWord37: "씨",
    KoreanWord37EngTranslation: "Mr./Ms.",
    PostKoreanWord37: "was the first person I recognized.",

    PreKoreanWord38: "I think I might be",
    KoreanWord38: "그렇다",
    KoreanWord38EngTranslation:
      "correct, that's right; to be so, to be that way",
    PostKoreanWord38: ", things haven't changed too much.",

    PreKoreanWord39: "The town had become more",
    KoreanWord39: "크다",
    KoreanWord39EngTranslation: "large",
    PostKoreanWord39: "with new developments.",

    PreKoreanWord40: "He greeted me and said he",
    KoreanWord40: "또",
    KoreanWord40EngTranslation: "again",
    PostKoreanWord40: "thought about calling me recently.",

    PreKoreanWord41: "He asked if I was",
    KoreanWord41: "일 하다",
    KoreanWord41EngTranslation: "to work",
    PostKoreanWord41: "and had treated me well.",

    PreKoreanWord42: "I told him",
    KoreanWord42: "사회",
    KoreanWord42EngTranslation: "society",
    PostKoreanWord42: "was getting faster and more competitive.",

    PreKoreanWord43: "There were",
    KoreanWord43: "많다",
    KoreanWord43EngTranslation: "many",
    PostKoreanWord43: "good moments, and many difficult ones.",

    PreKoreanWord44: "I sometimes felt I could",
    KoreanWord44: "안",
    KoreanWord44EngTranslation: "not; inside, within",
    PostKoreanWord44: "do everything I wanted to.",

    PreKoreanWord45: "He smiled and said it was",
    KoreanWord45: "좋다",
    KoreanWord45EngTranslation: "good",
    PostKoreanWord45: "that I had come back.",

    PreKoreanWord46: "I felt my heart grow",
    KoreanWord46: "더",
    KoreanWord46EngTranslation: "more",
    PostKoreanWord46: "warmer with each familiar sight.",

    PreKoreanWord47: "Then my mother opened the door to",
    KoreanWord47: "받다",
    KoreanWord47EngTranslation: "to receive",
    PostKoreanWord47: "me home again.",

    PreKoreanWord48: "To her,",
    KoreanWord48: "그것",
    KoreanWord48EngTranslation: "that",
    PostKoreanWord48: "moment meant everything.",

    PreKoreanWord49: "She pulled me into the",
    KoreanWord49: "집",
    KoreanWord49EngTranslation: "house",
    PostKoreanWord49: "with tears in her eyes.",

    PreKoreanWord50: "And suddenly all the feelings",
    KoreanWord50: "나오다",
    KoreanWord50EngTranslation: "to come out, to emerge",
    PostKoreanWord50: "during this reunion.",
  },

  {
    lessonNumber: 2,
    lessonTitle: "The Woman I Once Knew",

    PreKoreanWord1: "As the train slowed down, my memories",
    KoreanWord1: "따르다",
    KoreanWord1EngTranslation: "to follow; to pour; to love",
    PostKoreanWord1: "me like a quiet shadow.",

    PreKoreanWord2: "I looked out the window,",
    KoreanWord2: "그리고",
    KoreanWord2EngTranslation: "and",
    PostKoreanWord2: "wondered if the town had changed.",

    PreKoreanWord3: "There had always been one unresolved",
    KoreanWord3: "문제",
    KoreanWord3EngTranslation: "problem",
    PostKoreanWord3: "between us.",

    PreKoreanWord4: "But she simply said it wasn’t",
    KoreanWord4: "그런",
    KoreanWord4EngTranslation: "such, that kind of",
    PostKoreanWord4: "a big deal anymore.",

    PreKoreanWord5: "She used to",
    KoreanWord5: "살다",
    KoreanWord5EngTranslation: "to live",
    PostKoreanWord5: "near the old market street.",

    PreKoreanWord6: "Back then,",
    KoreanWord6: "저",
    KoreanWord6EngTranslation: "I (humble)",
    PostKoreanWord6: "could barely talk to her without trembling.",

    PreKoreanWord7: "Whenever I tried to confess how I felt, I simply",
    KoreanWord7: "못하다",
    KoreanWord7EngTranslation: "to be unable to",
    PostKoreanWord7: "speak.",

    PreKoreanWord8: "Even now I still",
    KoreanWord8: "생각하다",
    KoreanWord8EngTranslation: "to think",
    PostKoreanWord8: "about what might have been.",

    PreKoreanWord9: "But I truly",
    KoreanWord9: "모르다",
    KoreanWord9EngTranslation: "to not know",
    PostKoreanWord9: "how she feels today.",

    PreKoreanWord10: "My heart beat quickly",
    KoreanWord10: "속",
    KoreanWord10EngTranslation: "inside",
    PostKoreanWord10: "as I stepped off the train.",

    PreKoreanWord11: "What kind of fate could",
    KoreanWord11: "만들다",
    KoreanWord11EngTranslation: "to make, create",
    PostKoreanWord11: "us meet again after all these years?",

    PreKoreanWord12: "It wasn’t the same",
    KoreanWord12: "데",
    KoreanWord12EngTranslation: "point, place",
    PostKoreanWord12: "as before, but it felt familiar.",

    PreKoreanWord13: "We had gone our own ways for",
    KoreanWord13: "두",
    KoreanWord13EngTranslation: "two",
    PostKoreanWord13: "very different reasons.",

    PreKoreanWord14: "Still, she was standing in",
    KoreanWord14: "앞",
    KoreanWord14EngTranslation: "front",
    PostKoreanWord14: "of me at the station.",

    PreKoreanWord15: "Life brings strange reunions in unexpected",
    KoreanWord15: "경우",
    KoreanWord15EngTranslation: "cases, situations",
    PostKoreanWord15: "like this.",

    PreKoreanWord16: "She looked around, lost somewhere",
    KoreanWord16: "중",
    KoreanWord16EngTranslation: "middle, among",
    PostKoreanWord16: "the crowd.",

    PreKoreanWord17: "I wondered",
    KoreanWord17: "어떤",
    KoreanWord17EngTranslation: "which, what kind of",
    PostKoreanWord17: "life she had lived.",

    PreKoreanWord18: "She smiled softly—she always smiled",
    KoreanWord18: "잘",
    KoreanWord18EngTranslation: "well",
    PostKoreanWord18: "no matter the situation.",

    PreKoreanWord19: "Even back then,",
    KoreanWord19: "그녀",
    KoreanWord19EngTranslation: "she",
    PostKoreanWord19: "was gentle and warm.",

    PreKoreanWord20: "We sat down to",
    KoreanWord20: "먹다",
    KoreanWord20EngTranslation: "to eat",
    PostKoreanWord20: "dinner nearby.",

    PreKoreanWord21: "She asked why I had suddenly",
    KoreanWord21: "오다",
    KoreanWord21EngTranslation: "to come",
    PostKoreanWord21: "back to this town.",

    PreKoreanWord22: "I told her I wanted to be",
    KoreanWord22: "자신",
    KoreanWord22EngTranslation: "oneself",
    PostKoreanWord22: "again, not the busy man I had become.",

    PreKoreanWord23: "She said the town’s",
    KoreanWord23: "문화",
    KoreanWord23EngTranslation: "culture",
    PostKoreanWord23: "hadn’t changed much.",

    PreKoreanWord24: "Only the value of",
    KoreanWord24: "원",
    KoreanWord24EngTranslation: "won (money); complex, center",
    PostKoreanWord24: "had gone down.",

    PreKoreanWord25: "We got quiet, lost in",
    KoreanWord25: "생각",
    KoreanWord25EngTranslation: "thought",
    PostKoreanWord25: "as we walked.",

    PreKoreanWord26: "I asked her about things, she said didn't know",
    KoreanWord26: "어떻다",
    KoreanWord26EngTranslation: "to be how, to be like",
    PostKoreanWord26: "do at times.",

    PreKoreanWord27: "She told me she now had two",
    KoreanWord27: "명",
    KoreanWord27EngTranslation: "counter for people",
    PostKoreanWord27: "children, a boy and a girl.",

    PreKoreanWord28: "We laughed as memories",
    KoreanWord28: "통하다",
    KoreanWord28EngTranslation: "to flow through, communicate",
    PostKoreanWord28: "and old stories returned to us.",

    PreKoreanWord29: "At one point she paused,",
    KoreanWord29: "그러다",
    KoreanWord29EngTranslation: "and then; while doing so",
    PostKoreanWord29: "looked away, and sighed.",

    PreKoreanWord30: "A faint",
    KoreanWord30: "소리",
    KoreanWord30EngTranslation: "sound",
    PostKoreanWord30: "of evening traffic filled the air.",

    PreKoreanWord31: "Meeting her felt like stepping into the past",
    KoreanWord31: "다시",
    KoreanWord31EngTranslation: "again",
    PostKoreanWord31: "after so long.",

    PreKoreanWord32: "But she was now a very",
    KoreanWord32: "다른",
    KoreanWord32EngTranslation: "different",
    PostKoreanWord32: "person from the one I remembered.",

    PreKoreanWord33: "Even so, something about this moment felt",
    KoreanWord33: "이런",
    KoreanWord33EngTranslation: "like this, such",
    PostKoreanWord33: "way and was comforting.",

    PreKoreanWord34: "I remembered the shy",
    KoreanWord34: "여자",
    KoreanWord34EngTranslation: "woman",
    PostKoreanWord34: "who once walked beside me.",

    PreKoreanWord35: "She now had a small",
    KoreanWord35: "개",
    KoreanWord35EngTranslation: "dog; unit counter",
    PostKoreanWord35: "running happily around her feet.",

    PreKoreanWord36: "We talked for a fair",
    KoreanWord36: "정도",
    KoreanWord36EngTranslation: "amount, degree",
    PostKoreanWord36: "of time before evening fell.",

    PreKoreanWord37: "As we walked, the sun set",
    KoreanWord37: "뒤",
    KoreanWord37EngTranslation: "behind",
    PostKoreanWord37: "us.",

    PreKoreanWord38: "The street grew quiet, allowing us to",
    KoreanWord38: "듣다",
    KoreanWord38EngTranslation: "to hear",
    PostKoreanWord38: "only our footsteps.",

    PreKoreanWord39: "We talked about",
    KoreanWord39: "다",
    KoreanWord39EngTranslation: "all, everything",
    PostKoreanWord39: "that had changed in our lives.",

    PreKoreanWord40: "She looked at me with",
    KoreanWord40: "좀",
    KoreanWord40EngTranslation: "a little",
    PostKoreanWord40: "surprise when I said I regretted leaving.",

    PreKoreanWord41: "Old fears began to",
    KoreanWord41: "들다",
    KoreanWord41EngTranslation: "to enter, to feel",
    PostKoreanWord41: "my heart again.",

    PreKoreanWord42: "But I told her honestly that I still",
    KoreanWord42: "싶다",
    KoreanWord42EngTranslation: "to want",
    PostKoreanWord42: "to understand what we once were.",

    PreKoreanWord43: "Her eyes softened as if she could",
    KoreanWord43: "보이다",
    KoreanWord43EngTranslation: "to show, to appear",
    PostKoreanWord43: "my sincerity clearly.",

    PreKoreanWord44: "She said life changes us all, yet we still",
    KoreanWord44: "가지다",
    KoreanWord44EngTranslation: "to have, to possess",
    PostKoreanWord44: "the same hearts deep down.",

    PreKoreanWord45: "We stood quietly,",
    KoreanWord45: "함께",
    KoreanWord45EngTranslation: "together",
    PostKoreanWord45: "under the streetlight.",

    PreKoreanWord46: "A passing",
    KoreanWord46: "아이",
    KoreanWord46EngTranslation: "child",
    PostKoreanWord46: "laughed while chasing a bicycle.",

    PreKoreanWord47: "Moments like these seem to",
    KoreanWord47: "지나다",
    KoreanWord47EngTranslation: "to pass",
    PostKoreanWord47: "quickly yet stay forever.",

    PreKoreanWord48: "We had shared",
    KoreanWord48: "많이",
    KoreanWord48EngTranslation: "a lot",
    PostKoreanWord48: "of memories, even if life separated us.",

    PreKoreanWord49: "But tonight, for the first",
    KoreanWord49: "시간",
    KoreanWord49EngTranslation: "time; hour",
    PostKoreanWord49: "in years, I didn’t feel alone.",

    PreKoreanWord50: "She smiled and said",
    KoreanWord50: "너",
    KoreanWord50EngTranslation: "you",
    PostKoreanWord50: "take care of yourself.",
  },
  {
    lessonNumber: 3,
    lessonTitle: "Journeys of a Young Journalist",

    PreKoreanWord1: "My editor decided to",
    KoreanWord1: "주다",
    KoreanWord1EngTranslation: "to give",
    PostKoreanWord1: "me my first major assignment.",

    PreKoreanWord2: "I was to explore what it means to be",
    KoreanWord2: "인간",
    KoreanWord2EngTranslation: "a human being",
    PostKoreanWord2: "in our rapidly changing world.",

    PreKoreanWord3: "The",
    KoreanWord3: "사실",
    KoreanWord3EngTranslation: "fact",
    PostKoreanWord3: "was, I had never traveled far before.",

    PreKoreanWord4: "But excitement began to",
    KoreanWord4: "나다",
    KoreanWord4EngTranslation: "to come up, to arise",
    PostKoreanWord4: "as soon as I packed my bags.",

    PreKoreanWord5: "My thoughts were scattered—",
    KoreanWord5: "이렇다",
    KoreanWord5EngTranslation: "to be like this",
    PostKoreanWord5: "whenever I started something big.",

    PreKoreanWord6: "Before leaving, I hugged my",
    KoreanWord6: "어머니",
    KoreanWord6EngTranslation: "mother",
    PostKoreanWord6: "goodbye at the doorstep.",

    PreKoreanWord7: "She looked at me with worried",
    KoreanWord7: "눈",
    KoreanWord7EngTranslation: "eyes",
    PostKoreanWord7: "but said she believed in me.",

    PreKoreanWord8: "I laughed when she asked, “",
    KoreanWord8: "뭐",
    KoreanWord8EngTranslation: "what",
    PostKoreanWord8: "are you even going to write about?”",

    PreKoreanWord9: "I told her I would focus on small",
    KoreanWord9: "점",
    KoreanWord9EngTranslation: "points, details",
    PostKoreanWord9: "in people’s lives that reveal the bigger picture.",

    PreKoreanWord10: "My project would be",
    KoreanWord10: "의하다",
    KoreanWord10EngTranslation: "to be based on",
    PostKoreanWord10: "real experiences, not statistics alone.",

    PreKoreanWord11: "This",
    KoreanWord11: "시대",
    KoreanWord11EngTranslation: "era, age",
    PostKoreanWord11: "was changing too fast to stay home.",

    PreKoreanWord12: "The",
    KoreanWord12: "다음",
    KoreanWord12EngTranslation: "next",
    PostKoreanWord12: "morning, I boarded the first flight overseas.",

    PreKoreanWord13: "I felt uncertain, thinking, “Why is my life suddenly",
    KoreanWord13: "이러하다",
    KoreanWord13EngTranslation: "to be like this",
    PostKoreanWord13: "and moving so quickly?”",

    PreKoreanWord14: "On the plane,",
    KoreanWord14: "누구",
    KoreanWord14EngTranslation: "who",
    PostKoreanWord14: "would I even meet first?",

    PreKoreanWord15: "Before this job I had barely traveled",
    KoreanWord15: "전",
    KoreanWord15EngTranslation: "before",
    PostKoreanWord15: "outside my own town.",

    PreKoreanWord16: "But I was ready to visit new",
    KoreanWord16: "곳",
    KoreanWord16EngTranslation: "places",
    PostKoreanWord16: "and hear new stories.",

    PreKoreanWord17: "I planned to interview",
    KoreanWord17: "여러",
    KoreanWord17EngTranslation: "several, various",
    PostKoreanWord17: "different groups of people.",

    PreKoreanWord18: "Even though I felt nervous, I pretended I wasn’t",
    KoreanWord18: "안",
    KoreanWord18EngTranslation: "not",
    PostKoreanWord18: "scared at all.",

    PreKoreanWord19: "My first stop was a village where",
    KoreanWord19: "하나",
    KoreanWord19EngTranslation: "one",
    PostKoreanWord19: "teacher looked after dozens of children.",

    PreKoreanWord20: "She told me stories about her",
    KoreanWord20: "세계",
    KoreanWord20EngTranslation: "world",
    PostKoreanWord20: "and her hopes for her students.",

    PreKoreanWord21: "I almost cried listening, but I held back so I wouldn’t",
    KoreanWord21: "버리다",
    KoreanWord21EngTranslation: "to throw away, to burst out",
    PostKoreanWord21: "ruin the moment.",

    PreKoreanWord22: "A photo of the children hung",
    KoreanWord22: "위",
    KoreanWord22EngTranslation: "above",
    PostKoreanWord22: "her desk.",

    PreKoreanWord23: "She said she played",
    KoreanWord23: "운동",
    KoreanWord23EngTranslation: "sports",
    PostKoreanWord23: "with them every morning.",

    PreKoreanWord24: "Only about ten",
    KoreanWord24: "퍼센트",
    KoreanWord24EngTranslation: "percent",
    PostKoreanWord24: "of the village had access to a proper school.",

    PreKoreanWord25: "But she insisted that",
    KoreanWord25: "학교",
    KoreanWord25EngTranslation: "school",
    PostKoreanWord25: "meant more than buildings.",

    PreKoreanWord26: "She believed every child should learn to trust",
    KoreanWord26: "자기",
    KoreanWord26EngTranslation: "oneself",
    PostKoreanWord26: "and find their own path.",

    PreKoreanWord27: "She was the",
    KoreanWord27: "가장",
    KoreanWord27EngTranslation: "most",
    PostKoreanWord27: "dedicated person I had ever met.",

    PreKoreanWord28: "A former",
    KoreanWord28: "대통령",
    KoreanWord28EngTranslation: "president",
    PostKoreanWord28: "had even visited her school once.",

    PreKoreanWord29: "She gave each child three",
    KoreanWord29: "가지",
    KoreanWord29EngTranslation: "types, kinds",
    PostKoreanWord29: "of lessons: hope, discipline, and imagination.",

    PreKoreanWord30: "Listening to her made inspiration",
    KoreanWord30: "들다",
    KoreanWord30EngTranslation: "to enter, to feel",
    PostKoreanWord30: "my heart again.",

    PreKoreanWord31: "Stories like hers helped me",
    KoreanWord31: "시작하다",
    KoreanWord31EngTranslation: "to begin",
    PostKoreanWord31: "seeing life differently.",

    PreKoreanWord32: "That village wasn’t rich, but it felt like the",
    KoreanWord32: "바로",
    KoreanWord32EngTranslation: "exactly, just",
    PostKoreanWord32: "place I needed to be.",

    PreKoreanWord33: "From there, I traveled to",
    KoreanWord33: "어느",
    KoreanWord33EngTranslation: "some, a certain",
    PostKoreanWord33: "coastal town to continue my interviews.",

    PreKoreanWord34: "Each person I met had survived hardships, and",
    KoreanWord34: "그래서",
    KoreanWord34EngTranslation: "so, therefore",
    PostKoreanWord34: "they carried deep strength.",

    PreKoreanWord35: "I asked them gently, “",
    KoreanWord35: "무엇",
    KoreanWord35EngTranslation: "what",
    PostKoreanWord35: "keeps you moving forward?”",

    PreKoreanWord36: "Some blamed the",
    KoreanWord36: "정부",
    KoreanWord36EngTranslation: "government",
    PostKoreanWord36: "for not helping enough.",

    PreKoreanWord37: "Others said hardship touched",
    KoreanWord37: "모든",
    KoreanWord37EngTranslation: "every",
    PostKoreanWord37: "family sooner or later.",

    PreKoreanWord38: "In each",
    KoreanWord38: "번",
    KoreanWord38EngTranslation: "time, instance",
    PostKoreanWord38: "their stories surprised me.",

    PreKoreanWord39: "One fisherman pointed at his nets and said, “",
    KoreanWord39: "그거",
    KoreanWord39EngTranslation: "that thing",
    PostKoreanWord39: "is all I’ve had for decades.”",

    PreKoreanWord40: "He never earned much",
    KoreanWord40: "돈",
    KoreanWord40EngTranslation: "money",
    PostKoreanWord40: "but always kept going.",

    PreKoreanWord41: "He blamed",
    KoreanWord41: "국가",
    KoreanWord41EngTranslation: "the country",
    PostKoreanWord41: "for declining fish populations.",

    PreKoreanWord42: "But then he laughed and said, “",
    KoreanWord42: "그런데",
    KoreanWord42EngTranslation: "however, but",
    PostKoreanWord42: "I wouldn’t live anywhere else.”",

    PreKoreanWord43: "His words brightened my",
    KoreanWord43: "날",
    KoreanWord43EngTranslation: "day",
    PostKoreanWord43: "more than he realized.",

    PreKoreanWord44: "The more I traveled, the more I felt connected to",
    KoreanWord44: "여기",
    KoreanWord44EngTranslation: "here",
    PostKoreanWord44: "—everywhere I went.",

    PreKoreanWord45: "Each interview taught me something, and",
    KoreanWord45: "모두",
    KoreanWord45EngTranslation: "everyone",
    PostKoreanWord45: "had a story worth sharing.",

    PreKoreanWord46: "I met hardworking",
    KoreanWord46: "여성",
    KoreanWord46EngTranslation: "women",
    PostKoreanWord46: "running entire households alone.",

    PreKoreanWord47: "I met elderly men who spoke of lost",
    KoreanWord47: "친구",
    KoreanWord47EngTranslation: "friends",
    PostKoreanWord47: "with trembling voices.",

    PreKoreanWord48: "Their honesty touched my",
    KoreanWord48: "마음",
    KoreanWord48EngTranslation: "heart",
    PostKoreanWord48: "more deeply than I expected.",

    PreKoreanWord49: "At the end of each interview,",
    KoreanWord49: "후",
    KoreanWord49EngTranslation: "after",
    PostKoreanWord49: "I always thanked them for their time.",

    PreKoreanWord50: "As my journey came to an end, I knew I had to",
    KoreanWord50: "가다",
    KoreanWord50EngTranslation: "to go",
    PostKoreanWord50: "home with a changed perspective.",
  },
];
